
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Calendar, Newspaper, Images, Contact } from 'lucide-react';

const QuickLinks = () => {
  const links = [
    {
      title: 'Upcoming Events',
      description: 'Stay updated with diocesan programs and activities',
      icon: Calendar,
      path: '/events',
      color: 'bg-blue-500'
    },
    {
      title: 'Latest News',
      description: 'Read our latest announcements and updates',
      icon: Newspaper,
      path: '/news',
      color: 'bg-green-500'
    },
    {
      title: 'Photo Gallery',
      description: 'Browse through memorable moments and celebrations',
      icon: Images,
      path: '/gallery',
      color: 'bg-purple-500'
    },
    {
      title: 'Contact Us',
      description: 'Get in touch with our diocesan office',
      icon: Contact,
      path: '/contact',
      color: 'bg-yellow-500'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Quick Access
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Find what you're looking for quickly with these popular sections
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {links.map((link, index) => {
            const IconComponent = link.icon;
            return (
              <Link key={index} to={link.path} className="group">
                <Card className="h-full border-none shadow-lg hover:shadow-xl transition-all duration-300 group-hover:-translate-y-2">
                  <CardContent className="p-6 text-center">
                    <div className={`w-16 h-16 ${link.color} rounded-full mx-auto mb-4 flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                      <IconComponent className="h-8 w-8 text-white" />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2 group-hover:text-purple-600 transition-colors">
                      {link.title}
                    </h3>
                    <p className="text-gray-600">
                      {link.description}
                    </p>
                  </CardContent>
                </Card>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default QuickLinks;
